<template>
    <div class="session__register">
        <div class="session__register_header">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="session__register_header_details">
                            <div class="columns">
                                <div class="column">
                                    <view-actions
                                        :title="`${$t('ebs.sessions.register.title.date')} ${registerIndex} of ${sessionOccurrenceItems.length}: ${$t('ebs.sessions.register.title.register')}`"
                                        :size="'small'"
                                        :breadcrumb-active="true"
                                        :breadcrumb-items="[
                                            {
                                                name: $t('ebs.sessions.register.name.events'),
                                                to: eventsPath
                                            },
                                            {
                                                name: sessionEventName,
                                                to: sessionEventPath
                                            },
                                            {
                                                name: sessionDates,
                                                to: sessionPath
                                            }
                                        ]"
                                        :action-button-active="true"
                                        :custom-button-text="'Go back'"
                                        :custom-button-active="true"
                                        :cancel-button-active="false"
                                        :submit-button-active="false"
                                        @emit-custom="redirectBack"
                                    />
                                </div>
                            </div>
                                <div class="columns">
                                    <div class="column">
                                        <div class="session__register_header_details_description">{{ sessionDescription }}</div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="session__register_main">
            <div class="container">
                <div class="columns custom--inherit">
                    <div class="column">
                        <div class="session__register_main_numbers">
                            <component-text-columns
                                :items="[
                                    {
                                        label: 'Showing:',
                                        icon: '',
                                        content: registerCountAll
                                    },
                                    {
                                        label: 'Present:',
                                        icon: 'user-check',
                                        content: registerCountPresent
                                    },
                                    {
                                        label: 'Absent:',
                                        icon: 'user-x',
                                        content: registerCountAbsent
                                    }
                                ]"
                            ></component-text-columns>
                        </div>
                        <div class="session__register_main_bulk">
                            <component-bulk-actions
                                v-if="allowEdit"
                                :key="rerenderIndex"
                                :items="[
                                    {
                                        label: $t('ebs.sessions.register.labels.present'),
                                        value: true
                                    },
                                    {
                                        label: $t('ebs.sessions.register.labels.absent'),
                                        value: false
                                    }
                                ]"
                                @submit="bulkAction"
                            />
                        </div>
                        <div class="session__register_main_table">
                            <session-register-table
                                :key="rerenderIndex"
                                :items="register"
                                :disabled="!allowEdit"
                            />
                        </div>
                        <template v-if="allowEdit">
                            <div class="session__register_main_actions">
                                <div class="columns">
                                    <div class="column"></div>
                                    <div class="column is-narrow">
                                        <component-button
                                            :theme="'default'"
                                            :border="true"
                                            @click="resetRegister"
                                            :name="'session-register-main-actions-reset'"
                                        > {{ $t('ebs.sessions.register.buttons.resetChanges') }}
                                        </component-button>
                                    </div>
                                    <div class="column is-narrow">
                                        <component-button
                                            :border="true"
                                            :animate-loading="true"
                                            :animate-loading-event-name="'save-register'"
                                            :name="'session-register-main-actions-save'"
                                            @click="createRegister"
                                        >{{ $t('ebs.sessions.register.buttons.saveChanges') }}
                                        </component-button>
                                    </div>
                                    <template v-if="allowDisplayComplete">
                                        <div class="column is-narrow">
                                            <component-button
                                                :danger="true"
                                                :name="'session-register-main-actions-complete'"
                                                :disabled="!allowPerformComplete"
                                                @click="openCompleteRegisterNotify"
                                            >{{ $t('ebs.sessions.register.buttons.commit') }}
                                            </component-button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <template v-if="allowDisplayComplete && !allowPerformComplete">
                                <div class="session__register_main_note">
                                    <div class="columns">
                                        <div class="column"></div>
                                        <div class="column is-narrow">
                                            <component-note>The session must be finished and all attendance marked and saved in order to submit the register.</component-note>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="notifycompleteregister"
            :size="'medium'"
            :class="'pop__notify--complete'"
            :title-text="$t('ebs.sessions.register.notify.completeRegister')"
            :content-text="$t('ebs.sessions.register.notify.complitingText')"
            :cancel-button-text="$t('ebs.sessions.register.notify.cancel')"
            :submit-button-text="$t('ebs.sessions.register.notify.complete')"
            :submit-button-danger="true"
            :prevent-close="true"
            @emit-submit="completeRegister"
        />
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>

import ViewActions from '@/components/default/shared/ViewActions'
import ComponentBulkActions from '@/components/default/shared/ComponentBulkActions'
import SessionRegisterTable from '@/components/ebs/sessions/register/SessionRegisterTable'
import PopNotify from '@/components/default/shared/PopNotify'
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentTextColumns from '@/components/default/shared/ComponentTextColumns'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  components: {
    ComponentNote,
    ComponentTextColumns,
    ComponentButton,
    PopNotify,
    SessionRegisterTable,
    ComponentBulkActions,
    ViewActions
  },
  name: 'session-register',
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData),
      rerenderIndex: 0
    }
  },
  computed: {
    sessionEventId () {
      return this.$store.getters.getSessionEventId
    },
    sessionEventName () {
      return this.$store.getters.getSessionEventName
    },
    eventsPath () {
      return { name: 'ebs-event-list' }
    },
    sessionEventPath () {
      return { name: 'ebs-event-show', params: { id: this.sessionEventId } }
    },
    sessionDates () {
      return this.$store.getters.getSessionDates
    },
    sessionDescription () {
      return this.$t('ebs.sessions.register.return.completeTheRegister')
    },
    sessionId () {
      return this.$store.getters.getSessionId
    },
    sessionPath () {
      return {
        name: 'ebs-session-show',
        params: { eventId: this.$route.params.eventId, sessionId: this.$route.params.sessionId }
      }
    },
    sessionOccurrenceItems () {
      return this.$store.getters.getSessionOccurrenceItems
    },
    //
    sessionCompletionEnableRegisters () {
      return this.$store.getters.getSessionCompletionEnableRegisters
    },
    sessionCompletionRegistersEditByAnyCoordinator () {
      return this.$store.getters.getSessionCompletionRegistersEditByAnyCoordinator
    },
    sessionCompletionRegistersEditByTrainers () {
      return this.$store.getters.getSessionCompletionRegistersEditByTrainers
    },
    //
    register () {
      return this.$store.getters.getRegister
    },
    registerCountPresent () {
      return this.$store.getters.getRegisterCountPresent
    },
    registerCountAbsent () {
      return this.$store.getters.getRegisterCountAbsent
    },
    registerCountAll () {
      return this.$store.getters.getRegisterCountAll
    },
    registerLoaded () {
      return this.$store.getters.getRegisterCustomRequestLoaded
    },
    routeRegisterId () {
      return this.$route.params.registerId
    },
    registerIndex () {
      const items = this.sessionOccurrenceItems
      const registerId = this.routeRegisterId
      if (registerId) {
        return (items.findIndex(obj => obj.id === registerId) + 1)
      }
      return false
    },
    registerStatus () {
      return this.$store.getters.getRegisterStatus
    },
    //
    allowEdit () {
      return this.$store.getters.getRegisterAllowEdit
    },
    allowDisplayComplete () {
      return this.$store.getters.getRegisterAllowDisplayComplete
    },
    allowPerformComplete () {
      return this.$store.getters.getRegisterAllowPerformComplete
    }
  },
  watch: {
    register () {
      this.rerenderIndex++
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('ebs-session-register-submit')
    },
    redirectBack () {
      this.$router.push({
        name: 'ebs-session-show',
        hash: '#attendance-and-assessment',
        params: { eventId: this.$route.params.eventId, sessionId: this.$route.params.sessionId }
      })
    },
    //
    bulkAction (value) {
      for (let i = 0; i < value.indexes.length; i++) {
        this.$store.dispatch('setRegisterAttendance', { index: value.indexes[i], value: value.action })
      }
    },
    openCompleteRegisterNotify () {
      this.$refs.notifycompleteregister.openNotify()
    },
    closeCompleteRegisterNotify () {
      if (this.$refs.notifycompleteregister) {
        this.$refs.notifycompleteregister.closeNotify()
      }
    },
    //
    resetRegister () {
      this.$store.dispatch('resetRegister')
    },
    createRegister () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('createRegister').then(() => {
            this.getRegister()
          }).finally(() => {
            this.$eventBus.$emit('stop-save-register')
          })
          this.allowRedirectBeforeRouteLeave()
        } else {
          this.$refs.popnotifyvalidation.openNotify()
        }
      })
    },
    completeRegister () {
      this.$store.dispatch('completeRegister').finally(() => {
        this.closeCompleteRegisterNotify()
      })
      this.allowRedirectBeforeRouteLeave()
    },
    getRegister () {
      const registerId = this.$route.params.registerId
      this.$store.dispatch('getRegister', registerId)
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionregister";
</style>
